import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { Crown, Trophy } from "lucide-react";
import { Stars } from "@/components/travel/Stars";

export default function EliteLeaderboard() {
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/leaderboard/elite?limit=10").then(r => setUsers(r.data)).catch(()=>{}); }, []);
  if (!users.length) return null;
  return (
    <section className="max-w-6xl mx-auto px-4 pb-20">
      <div className="flex items-end justify-between mb-6">
        <h2 className="font-display text-3xl md:text-4xl font-bold flex items-center gap-2"><Trophy size={28} className="text-[#F59E0B]"/> Top voyageurs</h2>
        <span className="text-xs text-slate-500">Les plus actifs de la communauté</span>
      </div>
      <div className="glass-strong rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <tbody className="divide-y divide-slate-800">
            {users.map((u, i) => (
              <tr key={u.user_id} data-testid={`elite-row-${u.user_id}`} className="hover:bg-slate-900/60">
                <td className="px-4 py-3 w-12 text-center font-display font-bold text-lg text-[#F59E0B]">{i + 1}</td>
                <td className="px-4 py-3">
                  <Link to={`/profile/${u.user_id}`} className="flex items-center gap-3 hover:text-white">
                    <div className="w-8 h-8 rounded-full bg-slate-800 overflow-hidden flex items-center justify-center text-xs font-bold">
                      {u.picture ? <img src={u.picture} alt="" className="w-full h-full object-cover"/> : u.name?.[0]}
                    </div>
                    <div>
                      <div className="text-slate-100 font-semibold flex items-center gap-1">{u.name} {u.badges?.includes("elite") && <Crown size={12} className="text-fuchsia-400"/>}</div>
                      <div className="text-xs text-slate-400 flex items-center gap-2"><Stars value={u.rating_avg} size={10}/> {u.rating_avg}/5</div>
                    </div>
                  </Link>
                </td>
                <td className="px-4 py-3 text-right">
                  <div className="font-display text-lg font-bold text-slate-100">{u.missions_completed}</div>
                  <div className="text-[10px] text-slate-500">missions</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
